import React, { useState } from 'react';

import { Button } from "../../General/Button/Button.tsx";

interface Props {
    showCount?: number
    showButton: boolean,
    cardRef: React.RefObject<HTMLDivElement>,
}

/**
 * Компонент для отображения списка элементов с возможностью скрытия и показа
 * @param showCount - количество элементов для отображения в скрытом виде
 * @param showButton - индикатор отображения кнопки "Скрыть"
 * @param cardRef - ссылка на элемент, к которому нужно скроллить
 * @returns 
 */
export const CollapseList: React.FC<Props & React.HTMLAttributes<HTMLButtonElement>> = ({ children, showButton, cardRef, showCount = 3 }) => {
    const [isOpen, setIsOpen] = useState(false);//Индикатор открытия списка

    const count = React.Children.count(children);//Количество элементов в списке

    const MIN_COUNT_TO_SHOW_BUTTON = 30;//Минимальное количество элементов для показа кнопки "Скрыть"
    const MIN_COUNT_TO_SCROLL = 10;//Минимальное количество элементов для скролла к карточке

    /** Скрыть список */
    const closeList = () => {
        if (count > MIN_COUNT_TO_SCROLL) {
            cardRef.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
            setTimeout(() => {
                setIsOpen(false);
            }, 300);
        } else {
            setIsOpen(false);
        }
    };

    return (
        <>
            {isOpen && showButton && count > MIN_COUNT_TO_SHOW_BUTTON
                ? <Button type='text' onClick={closeList}>Скрыть</Button> : null}
            <div style={{
                height: `${(isOpen ? count : showCount) * 3.81}rem`,
                overflow: 'hidden',
                transition: 'height 0.3s ease-in-out'
            }}>
                {children}
            </div>
            {!isOpen && (count - showCount) > 0 && showButton
                ? <Button type='text' onClick={() => setIsOpen(true)}>{'Показать еще ' + (count - showCount)}</Button>
                : null}
            {isOpen && showButton ? <Button type='text' onClick={closeList}>Скрыть</Button> : null}
        </>
    );
};